import { render } from "./Edit.vue?vue&type=template&id=07c8825e"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Customers/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07c8825e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07c8825e', __exports__)) {
    api.reload('07c8825e', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=07c8825e", () => {
    api.rerender('07c8825e', render)
  })

}


export default __exports__